var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraphAlt4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 4C21 5.10457 20.1046 6 19 6C18.5327 6 18.1027 5.8397 17.7623 5.57109L13.9821 7.73119C13.9939 7.81911 14 7.90884 14 8C14 9.10457 13.1046 10 12 10C11.4505 10 10.9528 9.77841 10.5913 9.4197L6.99959 10.959C6.99986 10.9726 7 10.9863 7 11C7 12.1046 6.10457 13 5 13C3.89543 13 3 12.1046 3 11C3 9.89543 3.89543 9 5 9C5.54949 9 6.04722 9.22159 6.4087 9.5803L10.0004 8.04099C10.0001 8.02736 10 8.0137 10 8C10 6.89543 10.8954 6 12 6C12.4673 6 12.8973 6.1603 13.2377 6.42891L17.0179 4.26881C17.0061 4.18089 17 4.09116 17 4C17 2.89543 17.8954 2 19 2C20.1046 2 21 2.89543 21 4Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 9C17 8.44771 17.4477 8 18 8H20C20.5523 8 21 8.44772 21 9V19C21 19.5523 20.5523 20 20 20H18C17.4477 20 17 19.5523 17 19V9Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 12C10.4477 12 10 12.4477 10 13V19C10 19.5523 10.4477 20 11 20H13C13.5523 20 14 19.5523 14 19V13C14 12.4477 13.5523 12 13 12H11Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4 15C3.44772 15 3 15.4477 3 16V19C3 19.5523 3.44772 20 4 20H6C6.55228 20 7 19.5523 7 19V16C7 15.4477 6.55228 15 6 15H4Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2 21.25C1.58579 21.25 1.25 21.5858 1.25 22C1.25 22.4142 1.58579 22.75 2 22.75H22C22.4142 22.75 22.75 22.4142 22.75 22C22.75 21.5858 22.4142 21.25 22 21.25H2Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphAlt4);
export default __webpack_public_path__ + "static/media/graph-alt-4.c78e482a09d0d573bb68f5efc26a4c42.svg";
export { ForwardRef as ReactComponent };